import { isSpSize } from "../common/utils/isSpSize";

class Projects {
  // ---------------------------------------------------------------------------
  // --	Projects
  // ---------------------------------------------------------------------------

  constructor() {
    //DOM参照
    this.$page = document.querySelector("#page_home");
    this.$container = this.$page.querySelector(".p-home__container");
    this.$projects = document.querySelector(".p-home-projects");
    this.$wrapper = this.$projects.querySelector(".p-home-projects__wrapper");
    this.$info = this.$wrapper.querySelector(".p-home-project__info");
    this.$item = this.$wrapper.querySelector(".p-home-projects-item");

    //スクロールハンドリング
    window.addEventListener("scroll", this.update.bind(this));

    //リサイズハンドリング
    window.addEventListener("resize", this.update.bind(this));

    //初回のアップデート
    this.update();
  }

  // ---------------------------------------------------------------------------
  // --	アップデート
  // ---------------------------------------------------------------------------

  update() {
    //SPの時は処理なし
    if (isSpSize()) {
      this.$page.removeAttribute("style");
      this.$container.removeAttribute("style");
      this.$wrapper.removeAttribute("style");
      return;
    }

    //ページのスクロール値
    const scrollY = window.scrollY;

    //ヘッダーとウィンドウの高さ
    const headerH = document.querySelector("#global_header").clientHeight;
    const windowH = window.innerHeight;

    //スクロール範囲を計算
    const wrapperW = this.$wrapper.clientWidth;
    const innerW = this.$info.clientWidth + this.$item.clientWidth;
    const scrollRange = innerW - wrapperW;

    //コンテナとプロジェクトエリアの範囲
    const containerRect = this.$container.getBoundingClientRect();
    const projectsRect = this.$projects.getBoundingClientRect();

    //プロジェクトエリアのY座業（中心基準）を計算
    const projectsCenterY =
      projectsRect.y - containerRect.y + projectsRect.height / 2;
    const projectsY = projectsCenterY - (scrollY + (windowH - headerH) / 2);

    //ページの高さを固定
    this.$page.style.height = this.$container.clientHeight + headerH + "px";

    //状態の切り替え
    let top = -projectsY;
    if (top < 0) {
      top = 0;
      this.$page.style.marginBlockStart = "0px";
      this.$page.style.marginBlockEnd = scrollRange + "px";
      this.$container.style.position = "relative";
      this.$container.style.top = 0;
    } else if (top > scrollRange) {
      top = scrollRange;
      this.$page.style.marginBlockStart = scrollRange + "px";
      this.$page.style.marginBlockEnd = "0px";
      this.$container.style.position = "relative";
      this.$container.style.top = 0;
    } else {
      this.$container.style.position = "fixed";
      this.$container.style.top =
        -projectsCenterY + headerH + (windowH - headerH) / 2 + "px";
    }

    //横スクロール
    gsap.set(this.$wrapper, {
      x: -top,
    });
  }

  // ---------------------------------------------------------------------------
}

export default Projects;
